import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
const filter = createFilterOptions();

export default function EmbeddedAttachmentsSelect(props) {
    return (
        <Autocomplete
            onChange={(event, newValue) => {
                    // when a previously existing selection is made/cancelled
                    if (newValue && newValue.title) {

                        props.attachButton(newValue)
                    }
            }}
            filterOptions={(options, params) => {
                const filtered = filter(options, params); 
                return filtered;
            }}
            // autoSelect
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            defaultValue={props.fileNames}
            id="free-solo-with-text-demo"
            options={props.fileNames}
            getOptionLabel={(option) => {
                // Value selected with enter, right from the input
                if (typeof option === 'string') {
                    return option;
                }
                // Regular option
                return option.title;
            }}
            renderOption={(option) => option.title}
            size={'small'}
            style={{ width: "100%"}}
            freeSolo
            renderInput={(params) => (
                <div className="flex-centered">
                    <TextField {...params } label="Please select an attachment from the list"/>
                </div>
            )}
        />
    );
}